"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiChip = getMuiChip;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
/* eslint-disable max-lines */

function getMuiChip() {
  return {
    styleOverrides: {
      label: function (_ref) {
        var theme = _ref.theme;
        return {
          color: theme.palette.gray[700],
          paddingLeft: '0px',
          paddingRight: '0px'
        };
      },
      root: function (_ref2) {
        var ownerState = _ref2.ownerState,
          theme = _ref2.theme;
        return (0, _extends2["default"])({}, ownerState.hover && {
          '&:focus-visible': {
            boxShadow: "0px 0px 0px 4px ".concat(theme.palette.gray[100])
          },
          '&:hover': {
            cursor: 'pointer'
          }
        }, {
          '.MuiChip-avatar': {
            backgroundColor: 'transparent',
            height: '16px',
            margin: 0,
            width: '16px'
          },
          '.MuiChip-deleteIcon': {
            color: "".concat(theme.palette.gray[400], " !important"),
            height: '12px',
            margin: 0,
            width: '12px'
          },
          '.MuiChip-icon': {
            color: theme.palette.gray[500],
            height: '12px',
            margin: 0,
            'svg path': {
              stroke: 'currentColor',
              strokeWidth: 1.5
            },
            width: '12px'
          },
          backgroundColor: (ownerState == null ? void 0 : ownerState.variant) === 'filled' ? theme.palette.gray[50] : 'none',
          border: 'solid',
          borderColor: (ownerState == null ? void 0 : ownerState.variant) === 'filled' ? theme.palette.gray[200] : theme.palette.gray[600],
          borderRadius: '16px',
          borderWidth: (ownerState == null ? void 0 : ownerState.variant) === 'filled' ? '1px' : '1.5px',
          boxShadow: 'none',
          gap: 0
        });
      }
    },
    variants: [{
      props: {
        size: 'sm'
      },
      style: function (_ref3) {
        var theme = _ref3.theme;
        return (0, _extends2["default"])({}, theme.typography['text-xs-medium'], {
          height: 22,
          padding: '2px 8px 2px 8px'
        });
      }
    }, {
      props: {
        size: 'md'
      },
      style: function (_ref4) {
        var theme = _ref4.theme;
        return (0, _extends2["default"])({}, theme.typography['text-sm-medium'], {
          height: 24,
          padding: '2px 10px 2px 10px'
        });
      }
    }, {
      props: {
        size: 'lg'
      },
      style: function (_ref5) {
        var theme = _ref5.theme;
        return (0, _extends2["default"])({}, theme.typography['text-sm-medium'], {
          height: 28,
          padding: '4px 12px 4px 12px'
        });
      }
    }, {
      props: {
        size: 'sm',
        variant: 'badgeColor'
      },
      style: function () {
        return {
          borderRadius: '6px'
        };
      }
    }, {
      props: {
        size: 'md',
        variant: 'badgeColor'
      },
      style: function () {
        return {
          borderRadius: '6px'
        };
      }
    }, {
      props: {
        size: 'lg',
        variant: 'badgeColor'
      },
      style: function () {
        return {
          borderRadius: '8px'
        };
      }
    }, {
      props: {
        color: 'gray'
      },
      style: function (_ref6) {
        var ownerState = _ref6.ownerState,
          theme = _ref6.theme;
        return (0, _extends2["default"])({}, ownerState.hover && {
          '&:hover, &:focus-visible': {
            backgroundColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? theme.palette.gray[50] : theme.palette.gray[100],
            borderColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? theme.palette.gray[600] : theme.palette.gray[300]
          }
        }, {
          '.MuiChip-deleteIcon': {
            color: "".concat(theme.palette.gray[400], " !important")
          },
          '.MuiChip-icon': {
            color: theme.palette.gray[500]
          },
          '.MuiChip-label': {
            color: theme.palette.gray[700]
          },
          backgroundColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? 'none' : theme.palette.gray[50],
          borderColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? theme.palette.gray[600] : theme.palette.gray[200]
        });
      }
    }, {
      props: {
        color: 'primary'
      },
      style: function (_ref7) {
        var ownerState = _ref7.ownerState,
          theme = _ref7.theme;
        return (0, _extends2["default"])({}, ownerState.hover && {
          '&:hover, &:focus-visible': {
            backgroundColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? theme.palette.primary[50] : theme.palette.primary[100],
            borderColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? theme.palette.primary[600] : theme.palette.primary[300]
          }
        }, {
          '.MuiChip-deleteIcon': {
            color: "".concat(theme.palette.primary[400], " !important")
          },
          '.MuiChip-icon': {
            color: theme.palette.primary[500]
          },
          '.MuiChip-label': {
            color: theme.palette.primary[700]
          },
          backgroundColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? 'none' : theme.palette.primary[50],
          borderColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? theme.palette.primary[600] : theme.palette.primary[200]
        });
      }
    }, {
      props: {
        color: 'error'
      },
      style: function (_ref8) {
        var ownerState = _ref8.ownerState,
          theme = _ref8.theme;
        return (0, _extends2["default"])({}, ownerState.hover && {
          '&:hover, &:focus-visible': {
            backgroundColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? theme.palette.error[50] : theme.palette.error[100],
            borderColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? theme.palette.error[600] : theme.palette.error[300]
          }
        }, {
          '.MuiChip-deleteIcon': {
            color: "".concat(theme.palette.error[400], " !important")
          },
          '.MuiChip-icon': {
            color: theme.palette.error[500]
          },
          '.MuiChip-label': {
            color: theme.palette.error[700]
          },
          backgroundColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? 'none' : theme.palette.error[50],
          borderColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? theme.palette.error[600] : theme.palette.error[200]
        });
      }
    }, {
      props: {
        color: 'warning'
      },
      style: function (_ref9) {
        var ownerState = _ref9.ownerState,
          theme = _ref9.theme;
        return (0, _extends2["default"])({}, ownerState.hover && {
          '&:hover, &:focus-visible': {
            backgroundColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? theme.palette.warning[50] : theme.palette.warning[100],
            borderColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? theme.palette.warning[600] : theme.palette.warning[300]
          }
        }, {
          '.MuiChip-deleteIcon': {
            color: "".concat(theme.palette.warning[400], " !important")
          },
          '.MuiChip-icon': {
            color: theme.palette.warning[500]
          },
          '.MuiChip-label': {
            color: theme.palette.warning[700]
          },
          backgroundColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? 'none' : theme.palette.warning[50],
          borderColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? theme.palette.warning[600] : theme.palette.warning[200]
        });
      }
    }, {
      props: {
        color: 'success'
      },
      style: function (_ref0) {
        var ownerState = _ref0.ownerState,
          theme = _ref0.theme;
        return (0, _extends2["default"])({}, ownerState.hover && {
          '&:hover, &:focus-visible': {
            backgroundColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? theme.palette.success[50] : theme.palette.success[100],
            borderColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? theme.palette.success[600] : theme.palette.success[300]
          }
        }, {
          '.MuiChip-deleteIcon': {
            color: "".concat(theme.palette.success[400], " !important")
          },
          '.MuiChip-icon': {
            color: theme.palette.success[500]
          },
          '.MuiChip-label': {
            color: theme.palette.success[700]
          },
          backgroundColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? 'none' : theme.palette.success[50],
          borderColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? theme.palette.success[600] : theme.palette.success[200]
        });
      }
    }, {
      props: {
        color: 'blueLight'
      },
      style: function (_ref1) {
        var ownerState = _ref1.ownerState,
          theme = _ref1.theme;
        return (0, _extends2["default"])({}, ownerState.hover && {
          '&:hover, &:focus-visible': {
            backgroundColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? theme.palette.blueLight[50] : theme.palette.blueLight[100],
            borderColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? theme.palette.blueLight[600] : theme.palette.blueLight[300]
          }
        }, {
          '.MuiChip-deleteIcon': {
            color: "".concat(theme.palette.blueLight[400], " !important")
          },
          '.MuiChip-icon': {
            color: theme.palette.blueLight[500]
          },
          '.MuiChip-label': {
            color: theme.palette.blueLight[700]
          },
          backgroundColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? 'none' : theme.palette.blueLight[50],
          borderColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? theme.palette.blueLight[600] : theme.palette.blueLight[200]
        });
      }
    }, {
      props: {
        color: 'blue'
      },
      style: function (_ref10) {
        var ownerState = _ref10.ownerState,
          theme = _ref10.theme;
        return (0, _extends2["default"])({}, ownerState.hover && {
          '&:hover, &:focus-visible': {
            backgroundColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? theme.palette.blue[50] : theme.palette.blue[100],
            borderColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? theme.palette.blue[600] : theme.palette.blue[300]
          }
        }, {
          '.MuiChip-deleteIcon': {
            color: "".concat(theme.palette.blue[400], " !important")
          },
          '.MuiChip-icon': {
            color: theme.palette.blue[500]
          },
          '.MuiChip-label': {
            color: theme.palette.blue[700]
          },
          backgroundColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? 'none' : theme.palette.blue[50],
          borderColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? theme.palette.blue[600] : theme.palette.blue[200]
        });
      }
    }, {
      props: {
        color: 'indigo'
      },
      style: function (_ref11) {
        var ownerState = _ref11.ownerState,
          theme = _ref11.theme;
        return (0, _extends2["default"])({}, ownerState.hover && {
          '&:hover, &:focus-visible': {
            backgroundColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? theme.palette.indigo[50] : theme.palette.indigo[100],
            borderColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? theme.palette.indigo[600] : theme.palette.indigo[300]
          }
        }, {
          '.MuiChip-deleteIcon': {
            color: "".concat(theme.palette.indigo[400], " !important")
          },
          '.MuiChip-icon': {
            color: theme.palette.indigo[500]
          },
          '.MuiChip-label': {
            color: theme.palette.indigo[700]
          },
          backgroundColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? 'none' : theme.palette.indigo[50],
          borderColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? theme.palette.indigo[600] : theme.palette.indigo[200]
        });
      }
    }, {
      props: {
        color: 'purple'
      },
      style: function (_ref12) {
        var ownerState = _ref12.ownerState,
          theme = _ref12.theme;
        return (0, _extends2["default"])({}, ownerState.hover && {
          '&:hover, &:focus-visible': {
            backgroundColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? theme.palette.purple[50] : theme.palette.purple[100],
            borderColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? theme.palette.purple[600] : theme.palette.purple[300]
          }
        }, {
          '.MuiChip-deleteIcon': {
            color: "".concat(theme.palette.purple[400], " !important")
          },
          '.MuiChip-icon': {
            color: theme.palette.purple[500]
          },
          '.MuiChip-label': {
            color: theme.palette.purple[700]
          },
          backgroundColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? 'none' : theme.palette.purple[50],
          borderColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? theme.palette.purple[600] : theme.palette.purple[200]
        });
      }
    }, {
      props: {
        color: 'pink'
      },
      style: function (_ref13) {
        var ownerState = _ref13.ownerState,
          theme = _ref13.theme;
        return (0, _extends2["default"])({}, ownerState.hover && {
          '&:hover, &:focus-visible': {
            backgroundColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? theme.palette.pink[50] : theme.palette.pink[100],
            borderColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? theme.palette.pink[600] : theme.palette.pink[300]
          }
        }, {
          '.MuiChip-deleteIcon': {
            color: "".concat(theme.palette.pink[400], " !important")
          },
          '.MuiChip-icon': {
            color: theme.palette.pink[500]
          },
          '.MuiChip-label': {
            color: theme.palette.pink[700]
          },
          backgroundColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? 'none' : theme.palette.pink[50],
          borderColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? theme.palette.pink[600] : theme.palette.pink[200]
        });
      }
    }, {
      props: {
        color: 'orange'
      },
      style: function (_ref14) {
        var ownerState = _ref14.ownerState,
          theme = _ref14.theme;
        return (0, _extends2["default"])({}, ownerState.hover && {
          '&:hover, &:focus-visible': {
            backgroundColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? theme.palette.orange[50] : theme.palette.orange[100],
            borderColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? theme.palette.orange[600] : theme.palette.orange[300]
          }
        }, {
          '.MuiChip-deleteIcon': {
            color: "".concat(theme.palette.orange[400], " !important")
          },
          '.MuiChip-icon': {
            color: theme.palette.orange[500]
          },
          '.MuiChip-label': {
            color: theme.palette.orange[700]
          },
          backgroundColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? 'none' : theme.palette.orange[50],
          borderColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? theme.palette.orange[600] : theme.palette.orange[200]
        });
      }
    }, {
      props: {
        color: 'grayBlue'
      },
      style: function (_ref15) {
        var ownerState = _ref15.ownerState,
          theme = _ref15.theme;
        return (0, _extends2["default"])({}, ownerState.hover && {
          '&:hover, &:focus-visible': {
            backgroundColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? theme.palette.grayBlue[50] : theme.palette.grayBlue[100],
            borderColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? theme.palette.grayBlue[600] : theme.palette.grayBlue[300]
          }
        }, {
          '.MuiChip-deleteIcon': {
            color: "".concat(theme.palette.grayBlue[400], " !important")
          },
          '.MuiChip-icon': {
            color: theme.palette.grayBlue[500]
          },
          '.MuiChip-label': {
            color: theme.palette.grayBlue[700]
          },
          backgroundColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? 'none' : theme.palette.grayBlue[50],
          borderColor: (ownerState == null ? void 0 : ownerState.variant) === 'outlined' ? theme.palette.grayBlue[600] : theme.palette.grayBlue[200]
        });
      }
    }]
  };
}